import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/site-header.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/site-header.css');
const js = require('!raw-loader!./siteHeader.js');

export const SiteHeaderDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css} js={js}>
    <p>
      You could use this kind of component for a header on your website or web
      app.
    </p>

    <p>
      The typical method for building this component would be to wrap the logo
      and nav buttons inside of one element, and the &ldquo;Settings&rdquo; and
      &ldquo;Log out&rdquo; buttons inside another element. And then you would
      use <code>float</code> to push one container to the left, and the other
      container to the right. And <em>then</em> you would need a clearfix on the
      site header itself. That&rsquo;s a lot of rigamarole for a simple layout!
    </p>

    <p>
      With flexbox, you still need the container elements, but you don&rsquo;t
      need special classes for these containers since flexbox puts the parent in
      charge of the layout.
    </p>

    <p>
      Our trusty <code>display: flex</code> property is at work here, but a
      couple other flexbox properties further adjust the layout:
    </p>

    <ul>
      <li>
        <code>justify-content: space-between</code> pushes the child elements
        are far away from one another as possible. This pushes the logo and nav
        buttons left and the settings button right.
      </li>
      <li>
        <code>align-items: center</code> centers all of the children elements
        vertically along the main axis within the containers themselves. This is
        important because the logo and nav buttons are of different heights.
        Without setting this property, they would align to their top edges by
        default.
      </li>
    </ul>
  </DemoPage>
);

SiteHeaderDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/SiteHeaderDemo.js